import React from 'react';

import { useStore } from 'utils/hooks/store';

import { DROP_ZONE_EL_ID, MAX_LOGO_SIZE, SUPPORTED_IMAGE_TYPES } from 'core/constants';

import { UploadIcon } from 'components/Icons/UploadIcon';

import useFileUpload from 'utils/hooks/useFileUpload';

import { UploadContainer, UploadButton } from './styles';

const UploadFile: React.FunctionComponent<{ setNewLogo: (file: File) => void; uploadFile: () => void }> = ({
  setNewLogo,
  uploadFile,
}): React.ReactElement => {
  const { notification } = useStore();

  const handleDroppedFiles = (file: File): void => {
    if (SUPPORTED_IMAGE_TYPES.includes(file.type)) {
      if (file.size > MAX_LOGO_SIZE) {
        notification.enqueueErrorSnackbar('File size exceeds the limit of 2 MB.');
        return;
      }
      setNewLogo(file);
    } else {
      notification.enqueueErrorSnackbar('Unsupported file format. Please select a PNG or JPEG file.');
    }
  };

  const { dragActive, dropZoneRef } = useFileUpload(handleDroppedFiles);

  return (
    <UploadContainer ref={dropZoneRef} data-testid={DROP_ZONE_EL_ID} $dragActive={dragActive}>
      <UploadIcon />
      <h1>
        Drag and drop or{' '}
        <UploadButton type="button" onClick={uploadFile}>
          upload
        </UploadButton>{' '}
        your logo here
      </h1>
      <p>
        The logo should be in PNG or JPG format and have a maximum file size of 2 MB. Ideally, it should be horizontal
        and proportioned to fit a space of 106 x 30 pixels.
      </p>
    </UploadContainer>
  );
};

export default UploadFile;
